// extracted by mini-css-extract-plugin
module.exports = {"checkboxMargin":"CheckBoxList_checkboxMargin__3YS9X","labelCheckBox":"CheckBoxList_labelCheckBox__2RKU-"};